import { useEffect } from "react";
import { motion, useAnimation, useMotionValue } from "motion/react";

const CircularText = ({
  text = "GET STARTED NOW * GET STARTED NOW *",
  spinDuration = 20,
  className = "",
}) => {
  const controls = useAnimation();
  const rotation = useMotionValue(0);

  useEffect(() => {
    const start = rotation.get();
    controls.start({
      rotate: start + 360,
      transition: {
        duration: spinDuration,
        ease: "linear",
        repeat: Infinity,
      },
    });
  }, [spinDuration, controls, rotation]);

  const handleHoverStart = () => {
    const start = rotation.get();
    controls.start({
      rotate: start + 360,
      transition: {
        duration: spinDuration / 4,
        ease: "linear",
        repeat: Infinity,
      },
    });
  };

  const handleHoverEnd = () => {
    const start = rotation.get();
    controls.start({
      rotate: start + 360,
      transition: {
        duration: spinDuration,
        ease: "linear",
        repeat: Infinity,
      },
    });
  };

  return (
    <div className={`relative w-[120px] h-[120px] ${className}`}>
      {/* Background Circle */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#6cfcb5] to-[#F0FF6C]" />

      <motion.div
        className="absolute inset-0 rounded-full"
        style={{ rotate: rotation }}
        animate={controls}
        onMouseEnter={handleHoverStart}
        onMouseLeave={handleHoverEnd}
      >
        {/* Center Arrow */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 44 45"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.2557 10.2031C27.9411 13.5177 21.7748 13.3932 18.3207 9.93912L16.9045 8.52293L14.1855 11.242L15.6016 12.6582C18.114 15.1705 21.5282 16.4694 24.9188 16.5399L8.14343 33.3154L10.9758 36.1477L27.7512 19.3723C27.8218 22.7629 29.1206 26.1772 31.6329 28.6895L33.0491 30.1057L35.7682 27.3866L34.352 25.9704C30.8979 22.5163 30.7735 16.3501 34.0881 13.0355L35.4476 11.676L32.6152 8.84357L31.2557 10.2031Z"
              fill="#0C1F20"
            ></path>
          </svg>
        </div>

        {/* Circular Text */}
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          className="absolute inset-0"
        >
          <defs>
            <path
              id="circlePath"
              d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0"
            />
          </defs>

          <motion.text
            fill="#0C1F20"
            fontSize="10.5"
            fontWeight="700"
            letterSpacing="1.5"
          >
            <textPath href="#circlePath" startOffset="50%" textAnchor="middle">
              VIEW MY RESUME * VIEW MY RESUME *
            </textPath>
          </motion.text>
        </svg>
      </motion.div>
    </div>
  );
};

export default CircularText;
